module.exports = __webpack_public_path__ + "static/media/b3.b11ce272.jpg";